import create from 'zustand'

export const useStore = create(set => ({
    answeredQestions: 15,
    scoreKremik: 0,
    scoreZlato: 0,
    textOdpoved: "",
    hideButton: [],
    videoUrl: "",
    pridajZlatoScore: (points) => set(state => ({ scoreZlato: state.scoreZlato + points  })),
    pridajKremikScore: (points) => set(state => ({ scoreKremik: state.scoreKremik + points})),
    odoberZlatoScore: (points) => set(state => ({ scoreZlato: state.scoreZlato - points })),
   odoberKremikScore: (points) => set(state => ({ scoreKremik: state.scoreKremik - points })),
    addAnsweredQuestions: () => set(state => ({ answeredQestions: state.answeredQestions + 1 })),
    setVideoUrl: (videoUrl) => set(state => ({ videoUrl })),
    settextOdpoved: (textOdpoved) => set(state => ({ textOdpoved })),
    setActive: (hideButton) => set(state => ({hideButton: [...state.hideButton,hideButton]}))
}))

